// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Discount from '../_raw/ui/icon_discount.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Discount);
